module.exports = __webpack_public_path__ + "static/media/yalo-icone.9dcc7d6a.png";